import { Style } from '../Commons/Styles.jsx';
import { useRef, useState, useEffect } from "react";
import Validate from '../Commons/Validate';


const InputFieldCustom = (props) => {
    const {
        type, placeholder, readOnly, width, value, setValue, required,
        money, component, options, date, onChange, search, error, setError,
        columns, referenceCol
    } = props;
    const timer = useRef(null);
    const [color, setColor] = useState('#EFEFEF');

    useEffect(() => {
        (async () => {
            try {
                if (error)
                    setColor('red');
                else
                    setColor('#EFEFEF');
            }
            catch (e) {
                console.log(e);
            }
        })();
    }, [error]);

    // El campo "textarea" vive dentro de su propio col-12, mientras que sus pares de una
    // sola linea normalmente viven en columnas mas angostas (col-6, col-3, etc.) dentro de
    // una fila de N columnas iguales. Si a ambos se les da el mismo "width" en %, el
    // textarea (que parte de un contenedor N veces mas ancho) termina dejando un margen
    // vacio a la derecha N veces mas grande en pixeles, y su borde derecho no coincide con
    // el borde derecho del ultimo campo de la fila (o seccion) de referencia. Para que ambos
    // terminen en el mismo punto, el textarea debe "encogerse" solo 1/N de lo que se encoge
    // un campo de una sola columna con el mismo width, donde N = 12 / (ancho de columna de
    // esa fila de referencia).
    //
    // "referenceCol" es la forma recomendada de indicar esa fila: se pasa tal cual la MISMA
    // clase "col-N" que ya usan los campos normales con los que este textarea debe alinear
    // (ej. referenceCol="col-4" si la fila de arriba tiene 3 campos col-4, o referenceCol=
    // "col-3" si el resto de la pantalla usa el modulo de 4-por-fila). Existe justamente para
    // no tener que calcular "12 / N" a mano cada vez -- ese calculo mental es lo que se
    // olvida o se hace mal cada vez que se agrega un textarea nuevo, que es el motivo por el
    // que este bug de alineacion se repetia.
    //
    // "columns" (el numero ya calculado, 12/N) se sigue aceptando por compatibilidad con
    // pantallas que ya lo pasaban asi antes de que existiera "referenceCol". Si no se pasa
    // ninguno de los dos, se usa 2 (equivalente a col-6) para no romper pantallas viejas que
    // ya dependian de ese default -- pero en ese caso, si el textarea esta en col-12, se
    // emite un aviso en consola (ver renderComponent) para que el problema se note de
    // inmediato en desarrollo en vez de descubrirse a simple vista despues.
    const DEFAULT_TEXTAREA_REFERENCE_COLUMNS = 2;

    const resolveReferenceColumns = (referenceColClass, legacyColumns) => {
        if (referenceColClass) {
            const match = /^col-(\d+)$/.exec(String(referenceColClass).trim());
            const span = match ? parseInt(match[1], 10) : NaN;
            if (span > 0 && span <= 12) return 12 / span;
        }
        if (legacyColumns) return legacyColumns;
        return null;
    };

    const computeTextareaWidth = (widthValue, referenceColumns) => {
        const raw = widthValue || '80%';
        const match = /^([\d.]+)%$/.exec(String(raw).trim());
        if (!match) return raw;
        const percent = parseFloat(match[1]);
        const shrink = (100 - percent) / (referenceColumns || DEFAULT_TEXTAREA_REFERENCE_COLUMNS);
        return `${100 - shrink}%`;
    };

    const onChangeDefaultSelect = (props) => {
        let valueinfo = props.target.value;
        setValue(valueinfo);
        if (onChange) {
            onChange(props);
        }
    }

    const onChangeDefault = (props) => {
        let valueinfo = props.target.value;
        setValue(valueinfo);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => {
            if (money) {
                let decimals = (valueinfo.indexOf('.') !== -1) ? (valueinfo.length - valueinfo.indexOf('.') - 1) : 0;
                let valuemoney = valueinfo.replace(/[^0-9.-]/g, '');
                if (isNaN(valuemoney) || valuemoney === '') {
                    setValue('0.00');
                    return;
                }

                let money = decimals > 2 ? parseFloat(valuemoney) * (Math.pow(10, (decimals - 2))) : parseFloat(valuemoney);
                if (money > 9999999999999) {
                    let newprice = parseFloat(value.replace(/[^0-9.-]/g, ''));
                    setValue(newprice.toLocaleString("es-GT", { style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2 }))
                    return;
                }

                setValue(money.toLocaleString("es-GT", { style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2 }));

            }

            if (!Validate(props.target.value, { required: required, money: money, date: date })) {
                setColor('red')
            } else {
                setColor('#EFEFEF');
                if (setError)
                    setError(false);
            }

            if (onChange) {
                onChange(props);
            }

        }, 500);

    };

    function renderComponent(component) {
        switch (component) {
            case 'textarea': {
                const resolvedReferenceColumns = resolveReferenceColumns(referenceCol, columns);
                if (process.env.NODE_ENV !== 'production' && props.col === 'col-12' && !resolvedReferenceColumns) {
                    console.warn(
                        `InputFieldCustom: el textarea "${props.label || '(sin label)'}" esta en col-12 pero no recibio ` +
                        `"referenceCol" (ej. referenceCol="col-4" si la fila/seccion con la que debe alinear usa col-4). ` +
                        `Sin esto se usa un default de ${DEFAULT_TEXTAREA_REFERENCE_COLUMNS} columnas que probablemente no ` +
                        `coincide, y el borde derecho del textarea va a quedar desalineado.`
                    );
                }
                return (
                    <div class="row">
                        <div class="col-12">
                            <textarea className="InputField" type={type} onChange={(event) => onChangeDefault(event)} placeholder={placeholder} style={{ borderColor: color, width: computeTextareaWidth(width, resolvedReferenceColumns), minHeight: '5em' }} readOnly={readOnly} value={value} />
                        </div>
                    </div>
                );
            }
            case 'select':
                // Antes el <select> no tenia "value" -- React lo trataba como un elemento NO
                // controlado, y marcar "selected" en cada <option> solo definia la seleccion
                // inicial del DOM la primera vez que se montaba. Cuando el usuario elegia una
                // opcion a mano andaba bien (el navegador ya muestra esa seleccion apenas ocurre
                // el click, antes de que React vuelva a renderizar), pero cuando el valor se
                // preseleccionaba por codigo DESPUES del montaje (ej. Moneda o Cuenta de Pago en
                // ProviderPayableInvoiceShow.jsx) el estado de React quedaba bien pero el <select>
                // en pantalla no se enteraba: React no vuelve a tocar "selected" en <option> en
                // renders posteriores para un select no controlado. Con "value" en el propio
                // <select>, React lo controla de verdad y lo mantiene sincronizado en cualquier
                // render, sea por click del usuario o por una preseleccion programada.
                return (
                    <div class="row">
                        <div class="col-12">
                            <select disabled={readOnly} value={value} onChange={(e) => { onChangeDefaultSelect(e) }} style={{ ...Style.SelectCustom, width: width }}>
                                {
                                    options.map((item) => (
                                        <option key={item.key} value={item.key}>{item.value}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                );
            case 'search':
                return (
                    <div class="row">
                        <div class="col-9">
                            <input className="InputField" type={type} placeholder={placeholder} style={{ borderColor: color, width: width ? width : '80%' }} readOnly={readOnly} value={value} />
                        </div>
                        <div class="col-3">
                            {search}
                        </div>
                    </div>
                );
            case 'input':
            default:
                return (
                    <div class="row">
                        <div class="col-12">
                            <input className="InputField" type={type} onChange={(event) => onChangeDefault(event)} placeholder={placeholder} style={{ borderColor: color, width: width ? width : '80%' }} readOnly={readOnly} value={value} />
                        </div>
                    </div>
                );
        }
    }


    return (
        <div class={props.col ? props.col : "col-6"}>
            <div class="row" style={{ paddingTop: '1.2em' }}>
                <div class="col-12">
                    <label style={Style.InputFieldLabel}>{props.label}</label>
                </div>
            </div>
            {renderComponent(component)}
        </div >
    );
};

export default InputFieldCustom;